import { render, staticRenderFns } from "./ContractsListAddNew.vue?vue&type=template&id=6174fa15"
import script from "./ContractsListAddNew.vue?vue&type=script&lang=js"
export * from "./ContractsListAddNew.vue?vue&type=script&lang=js"
import style0 from "./ContractsListAddNew.vue?vue&type=style&index=0&id=6174fa15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports